const NAME = "TYPES_OF_OBJECTIVES";

export default NAME;
